subscribeToFragment